import { Injectable } from "@angular/core";
import { AppConfigService } from "./common/service/mpvAppConfigService";

@Injectable({
    providedIn: "root"
})
export class SigedCommonService {
    public APPLICATION_API_HOST: string = "";

    constructor(public appConfigService: AppConfigService) {
        switch (this.appConfigService.APLICACION_AMBIENTE) {
            case "localhost-nologin":
                 this.APPLICATION_API_HOST = "http://localhost:8088/api-sgd";
                break;
            case "desarrollo":
                //this.APPLICATION_API_HOST = "https://apidev.sunass.gob.pe/api-sgd";
                this.APPLICATION_API_HOST = "https://apiuat.sunass.gob.pe/api-sgd";
                break;
            case "produccion":
                this.APPLICATION_API_HOST = "https://api.sunass.gob.pe/api-sgd";
                break;
        }
    }
}
